import { DefaultTheme } from "styled-components";

const defaultTheme: DefaultTheme = {
  colors: {
    WHITE: "#FFFFFF",
    BLACK: "#202125",
    PURPLE_LIGHT: "#F0EBF8",
    PURPLE_MEDIUM: "#E1D7F1",
    PURPLE_HEAVY: "#673AB7",
    BLUE_LIGHT: "#EFF5FD",
    BLUE_MEDIUM: "#9bbfed",
    BLUE_HEAVY: "#0B24FB",
    GREY_LIGHT: "#F8F9FA",
    GREY_MEDIUM: "#F1F3F4",
    GREY_HEAVY: "#DADCE0",
    GREY_EXTRA_HEAVY: "#6B6F74",
    RED: "#d93025",
  },
};

export default defaultTheme;
